import script from "./ChooseRelativeProductDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./ChooseRelativeProductDialog.vue?vue&type=script&setup=true&lang=js"

import "./ChooseRelativeProductDialog.vue?vue&type=style&index=0&id=5369b462&lang=css"

const __exports__ = script;

export default __exports__